import React, { useState, useEffect } from 'react';
import Header from '../components/Layout/Header';
import LeftSidebar from '../components/Layout/LeftSidebar';
import RightSidebar from '../components/Layout/RightSidebar';
import Footer from '../components/Layout/Footer';
import HeroBanner from '../components/Layout/HeroBanner';
import PostFeed from '../components/PostFeed/PostFeed';
// import { useAuth } from '../context/AuthContext';
import './Dashboard.css';
import MobileSidebar from '../components/Layout/mobileSidebar';

const MOBILE_TABLET_BREAKPOINT = 1024; // px

const Dashboard: React.FC = () => {
  // const { user } = useAuth();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState<boolean>(
    () =>
      typeof window !== 'undefined'
        ? window.innerWidth <= MOBILE_TABLET_BREAKPOINT
        : true
  );

  useEffect(() => {
    const onResize = () =>
      setIsMobileOrTablet(window.innerWidth <= MOBILE_TABLET_BREAKPOINT);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <div className="dashboard">
      <Header />
      {/* Hamburger for mobile/tablet only */}
      {isMobileOrTablet && (
        <button
          className="hamburger-btn"
          aria-label="Open menu"
          onClick={() => setMobileSidebarOpen(true)}
        >
          <span className="hamburger-line" />
          <span className="hamburger-line" />
          <span className="hamburger-line" />
        </button>
      )}
      <br />
      <div className="dashboard-content">
        {/* show left/right sidebars on desktop */}
        {!isMobileOrTablet && <LeftSidebar />}
        <main className="main-content">
          <HeroBanner />
          <PostFeed />
        </main>
        {!isMobileOrTablet && <RightSidebar />}
      </div>
      {isMobileOrTablet && mobileSidebarOpen && (
        <MobileSidebar onClose={() => setMobileSidebarOpen(false)} />
      )}
      <br />
      <Footer />
    </div>
  );
};

export default Dashboard;
